@if (mensajeError) {
  <div class="alert alert-danger" role="alert">
    {{mensajeError}}
  </div>
}
<div class="body">
  <div class="container">
    <div class="consultaPerfilesIF">
      <div class="row title-box mt-3">
        <div class="col-12 col-sm-12">
          <h3 class="txtbienvenida">Consulta de perfiles <span class="txtbienvenida-2">Aliado
          Financiero</span></h3>
        </div>
      </div>

      <form class="custom-form" [formGroup]="consultaPerfilesForm">
        <div class="row justify-content-md-center mt-2">
          <div class="col-12 col-sm-6">
            <div class="mb-3 form-label">
              <label for="fechaInicio" class="form-label">Fecha inicial creación de usuario</label>
              <input type="date" max="{{fechaActual}}" class="form-control"
                formControlName="fechaInicio">
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="mb-3 form-label">
                <label for="fechaFin" class="form-label">Fecha final creación de usuario</label>
                <input type="date" max="{{fechaActual}}" class="form-control"
                  formControlName="fechaFin">
                </div>
              </div>
            </div>
            <div class="row justify-content-md-center mt-2">
              <div class="col-12 col-sm-6">
                <div class="mb-3 form-label">
                  <label for="estado" class="form-label">Estado</label>
                  <select name="miSelectEstado" class="form-control"
                    formControlName="estado" title="Seleccione una opción">
                    <option value="" disabled selected>Seleccione una opción</option>
                    @for (item of listaEstados; track item) {
                      <option [value]="item">{{item}}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <div class="mb-3 form-label">
                  <label for="miSelectRoles" class="form-label">Roles</label>
                  <select name="miSelectRoles" class="form-control selectpicker"
                    formControlName="listaRolesSeleccionadosId" title="Seleccione una opción" multiple>
                    @for (item of listaRoles; track item) {
                      <option [value]="item.idRol">{{item.nombre}}
                      </option>
                    }
                  </select>
                </div>
              </div>
            </div>
            <div class="row justify-content-md-center mt-3 g-3">
              <div class="col-12 col-sm-3 container-btn">
                <button class="btn btn-primary hvr-shrink" style="width: 180px;"
                (click)="consultarUsuarios()" type="submit">Consultar</button>
              </div>
              @if (listaUsuarios.length > 0) {
                <div class="col-12 col-sm-3 container-btn">
                  <button class="btn btn-primary hvr-shrink" style="width: 180px;"
                  (click)="descargarExcel()" type="submit">Exportar a Excel</button>
                </div>
              }
              @if (listaUsuarios.length > 0) {
                <div class="col-12 col-sm-3 container-btn">
                  <button class="btn btn-primary hvr-shrink" style="width: 180px;"
                  (click)="descargarTxt()" type="submit">Exportar a Txt</button>
                </div>
              }
              <div class="col-12 col-sm-3 container-btn ">
                <button class="btn  btn-primary hvr-shrink" style="width: 180px;"
                  routerLink="/intermediario/home">
                  Volver
                </button>
              </div>
            </div>
          </form>
        </div>

        @if (listaUsuarios.length > 0) {
          <div class="row mt-3 pr-3 pl-3">
            <div class="table-responsive">
              <table class="table table-striped table-borderless rounded">
                <thead class="table_head">
                  <tr>
                    <th scope="col" class="no-styles table-header" id="nombreUsuario">Nombre Usuario</th>
                    <th scope="col" class="no-styles table-header" id="tipoDoc">Tipo Documento</th>
                    <th scope="col" class="no-styles table-header" id="numeroDoc">Número Documento</th>
                    <th scope="col" class="no-styles table-header" id="rolesAsignados">Roles asignados
                    </th>
                    <th scope="col" class="no-styles table-header" id="fechaUltIngreso">Fecha Último
                      Ingreso
                    </th>
                    <th scope="col" class="no-styles table-header" id="estado">Estado</th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of listaUsuarios; track item) {
                    <tr>
                      <th scope="row">{{item.nombreCompleto}}</th>
                      <td>{{item.nombreDocumento}}</td>
                      <td>{{item.numeroDocumento}}</td>
                      <td>{{item.rolesConcatenados}}</td>
                      <td>{{item.fechaUltimoIngreso | date:'yyyy/MM/dd HH:mm'}}</td>
                      <td>{{item.estado}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
        @if (listaUsuarios.length>0) {
          <app-pagination (event)="selectPage($event)"
          [paginaActual]="paginaActual" [totalPaginas]="totalPaginas"></app-pagination>
        }
        <a id="downloadFile" style="display: none;"></a>
      </div>
      <!-- Modal -->
      <div class="modal fade text-center" id="mensajeModal" style="color: black;" tabindex="-1"
        aria-labelledby="mensajeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body justify-content-md-center">
              <div class="row">
                <div class="col-12 col-sm-12 me-3 ms-3">
                  <h2>Los criterios de busqueda ingresados no arrojaron resultados en la consulta</h2>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-md-center">
              <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Aceptar</button>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-body"></div>
    </div>
    <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
